import { render, staticRenderFns } from "./magic-paradise.vue?vue&type=template&id=55d4b732&scoped=true&"
import script from "./magic-paradise.vue?vue&type=script&lang=js&"
export * from "./magic-paradise.vue?vue&type=script&lang=js&"
import style0 from "./magic-paradise.vue?vue&type=style&index=0&id=55d4b732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4b732",
  null
  
)

export default component.exports